import React from 'react';

import { StockLengthsDefinition } from '@paragon/contract-library';

import { LumberLengthsField } from './LumberLengthsField';

interface Props {
  value: StockLengthsDefinition;
  onChange(value: StockLengthsDefinition): void;
}

export function StockLengthsField(props: Props) {
  if (Array.isArray(props.value)) {
    return (
      <LumberLengthsField
        label="Stock Lengths"
        placeholder="Example: 2', 4', 8'"
        sx={{ m: 1, flex: 1 }}
        values={props.value}
        onChange={props.onChange}
      />
    );
  }
  return null;
}
